import { NavLink, useNavigate } from 'react-router-dom';
import { GraduationCap, Search } from 'lucide-react';

const links = [
  { label: 'Home', to: '/academy', end: true },
  { label: 'Buying Guides', to: '/academy/category/buying-guides' },
  { label: 'Inspection Education', to: '/academy/category/inspection-education' },
  { label: 'Vehicle History', to: '/academy/category/vehicle-history' },
  { label: 'Mechanical Basics', to: '/academy/category/mechanical-basics' },
  { label: 'Marketplace Tips', to: '/academy/category/marketplace-tips' },
  { label: 'Videos', to: '/academy/videos' },
  { label: 'All Articles', to: '/academy/articles' },
];

export const AcademyNav = () => {
  const navigate = useNavigate();
  return (
    <header
      className="sticky top-0 z-50 border-b border-zinc-800/80 bg-[#0e0e10]/90 backdrop-blur-xl"
      data-testid="academy-nav"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center gap-4 h-16">
          <button
            onClick={() => navigate('/academy')}
            className="flex items-center gap-2 shrink-0"
            data-testid="academy-logo"
          >
            <span className="grid place-items-center w-8 h-8 rounded-lg bg-gradient-to-br from-orange-500 to-orange-600 shadow-lg shadow-orange-500/30">
              <GraduationCap className="w-5 h-5 text-white" />
            </span>
            <span className="font-bold tracking-tight text-white" style={{ fontFamily: 'Space Grotesk' }}>
              <span className="text-white">CARLENS</span>
              <span className="text-orange-500"> ACADEMY</span>
            </span>
          </button>

          <nav className="flex-1 overflow-x-auto no-scrollbar">
            <ul className="flex items-center gap-1 pr-16 md:pr-24">
              {links.map((l) => (
                <li key={l.to} className="shrink-0">
                  <NavLink
                    to={l.to}
                    end={l.end}
                    className={({ isActive }) =>
                      `px-3 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${
                        isActive
                          ? 'text-white bg-white/10'
                          : 'text-zinc-400 hover:text-white hover:bg-white/5'
                      }`
                    }
                    data-testid={`academy-nav-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                  >
                    {l.label}
                  </NavLink>
                </li>
              ))}
              <li className="shrink-0">
                <button
                  onClick={() => navigate('/academy/articles?focus=search')}
                  className="ml-1 flex items-center gap-1.5 px-3 py-2 rounded-full text-sm font-medium text-zinc-400 hover:text-white hover:bg-white/5 transition-colors"
                  data-testid="academy-nav-search"
                >
                  <Search className="w-4 h-4" /> Search
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default AcademyNav;
